import type { GovernmentFollowerResponse } from '@govinity/validation/public';

import Api from './base';

export const PATH = '/governments-followers';

class GovernmentFollowersApi extends Api<GovernmentFollowerResponse, object, object, object> {
  getPath() {
    return PATH;
  }

  async follow(governmentId: number): Promise<void> {
    await this.request<GovernmentFollowerResponse>({
      method: 'POST',
      url: `${this.getPath()}/${governmentId}`,
    });
  }

  async unfollow(governmentId: number): Promise<void> {
    await this.request({
      method: 'DELETE',
      url: `${this.getPath()}/${governmentId}`,
    });
  }

  async favorite(governmentId: number): Promise<void> {
    await this.request<GovernmentFollowerResponse>({
      method: 'PUT',
      url: `${this.getPath()}/${governmentId}/favorite`,
    });
  }
}

export default new GovernmentFollowersApi();
